import type { ParsedListingFilters } from '../types';

type FanficsFilterState = Partial<ParsedListingFilters> & {
  searchQuery?: string;
  /** Non-default sort is pass-through on SEO permalinks and must stay in fromUrl. */
  sortBy?: string;
};

/**
 * Builds a `fromUrl` (path + query) from the current client filter state,
 * to be passed to /api/v1/seo/redirect. Search query is intentionally
 * excluded, per requirement that free-text search must not become SEO state.
 * Sort (except default hotNew) is included so soft SEO navigations keep it.
 */
export const buildFromUrlFromFilters = (
  basePath: '/fanfics' | '/originals',
  filters: FanficsFilterState,
): string => {
  const queryParams = new URLSearchParams();

  if (filters.fandoms?.length) queryParams.set('fandoms', filters.fandoms.join(','));
  if (filters.tags?.length) queryParams.set('tags', filters.tags.join(','));
  if (filters.universes?.length) queryParams.set('universes', filters.universes.join(','));
  if (filters.statuses?.length) queryParams.set('statuses', filters.statuses.join(','));
  if (filters.ratings?.length) queryParams.set('ratings', filters.ratings.join(','));
  if (filters.characters?.length) queryParams.set('characters', filters.characters.join(','));
  if (filters.pairingCharacters?.length) {
    queryParams.set('pairingCharacters', filters.pairingCharacters.join(','));
  }
  if (filters.sortBy && filters.sortBy !== 'hotNew') {
    queryParams.set('sort', filters.sortBy);
  }

  const queryStr = queryParams.toString();
  return queryStr ? `${basePath}?${queryStr}` : basePath;
};
